<!--     
    Copyright (c) 2022 nVipani Technology Solutions Private Limited.
    All rights reserved.
  -->
<div
  fxLayout="column"
  fxLayoutGap="10px"
  fxLayoutAlign.gt-xs="center center"
  fxLayoutAlign.lt-sm="start center"
  class="nvc-total nvs-margin-custom nvc-mobile-margin"
  [formGroup]="userLoginForm"
  (keyup.enter)="signIn()"
>
  <div class="nvc-input-div" fxLayoutAlign="start start">
    <mat-icon
      class="place-self-center ws-cursor-pointer notranslate"
      (click)="backToHome()"
      svgIcon="arrow_back"
    >
    </mat-icon>
    <img
      (click)="backToHome()"
      class="whiteshop-logo ws-cursor-pointer"
      [src]="whiteShopIcon"
      alt="whiteShopIcon"
    />
  </div>
  <div fxLayout class="nvc-input-div nvc-margin-4">
    <div
      class="nvs-register-text"
      id="loginheading"
      fxFlex="100"
      fxLayoutAlign="start start"
    >
      Login
    </div>
  </div>
  <div class="nvc-input-div">
    <div
      class="nvc-input-login border-focus-blue"
      fxLayout="row"
      fxLayoutAlign="start center"
    >
      <input
        type="text"
        id="username"
        placeholder="Email / Phone Number"
        class="nvc-input-tag"
        formControlName="username"
        matInput
        required
        autofocus
      />
    </div>
    <div fxLayout>
      <div
        *ngIf="
          !validUsername() &&
          userLoginForm.controls['username'].dirty &&
          userLoginForm.controls['username'].touched
        "
      >
        <small id="usernameError" class="nvc-red">* Enter username</small>
      </div>
    </div>
  </div>
  <div class="nvc-input-div">
    <div
      class="nvc-input-login border-focus-blue"
      fxLayout="row"
      fxLayoutAlign="start center"
    >
      <input
        id="password"
        [type]="passwordType"
        placeholder="Password"
        class="nvc-input-tag"
        matInput
        formControlName="password"
        required
        #passwordField
        (blur)="
          !userLoginForm.controls['password'].dirty
            ? userLoginForm.controls['password'].markAsUntouched()
            : ''
        "
      />
      <mat-icon
        [svgIcon]="passwordVisibility ? 'eyeIcon' : 'eyeSlashIcon'"
        class="nvc-eye ws-cursor-pointer"
        (click)="togglePasswordVisibility()"
      >
      </mat-icon>
    </div>
    <div fxLayout>
      <div
        *ngIf="
          !validPassword() &&
          userLoginForm.controls['password'].dirty &&
          userLoginForm.controls['password'].touched
        "
      >
        <small id="passwordError" class="nvc-red">* Enter password</small>
      </div>
    </div>
  </div>
  <div class="nvc-input-div" fxLayout fxLayoutAlign="end center">
    <button
      id="forgotpassword"
      class="nvs-forgot-password ws-cursor-pointer border-focus-blue button-clear"
      (click)="OnClickForgotPassword()"
    >
      Forgot Password?
    </button>
  </div>
  <div class="nvc-input-div">
    <button
      class="nvc-button-register ws-cursor-pointer button-shadow-focus nvc-uppercase"
      id="signin"
      (click)="signIn()"
      [disabled]="!validCredentials()"
      [ngClass]="{ 'nvc-disabled ws-no-cursor-pointer': !validCredentials() }"
    >
      Continue
    </button>
  </div>
  <div
    *ngIf="showRegister"
    class="nvs-login-footer nvc-input-div"
    fxLayoutAlign="start start"
  >
    <div class="nvs-text-small" id="registerstore">
      Register account?
      <button
        (click)="register('B2B')"
        class="nvs-bold ws-cursor-pointer border-focus-blue button-clear"
      >
        Signup
      </button>
    </div>
  </div>
  <div class="nvs-text-terms nvc-input-div" *ngIf="showRegister">
    By providing your email you are agreeing to our
    <span>Terms & Conditions</span>
  </div>
</div>
